export function poistaSpinneri() {
  let spinneri = document.getElementById('dot-init');
  if (spinneri !== null) {
    spinneri.style.display = 'none';
  }
}
